import React, { useState } from "react";
import { KonfhubButton } from "../../../revampComponents/Atom/Buttons";
import CreateEventProfileModal from "./EventProfileModal/CreateEventProfileModal"; // adjust path if needed
import { dashboardColors, theme } from "../../../themes/Theme";
import { useHistory } from "react-router-dom";

const ProfileHeader = ({ fetchEventProfiles }) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const isCreateModalOpen = searchParams.get('create') === 'true';

  const handleCreateProfile = async (profileData) => {
    setShowModal(false);
  };

  return (
    <div className="profile-header">
      <div className="profile-heading">Profiles</div>
      <KonfhubButton onClick={() => setShowModal(true)}>Create Profile</KonfhubButton>

      <CreateEventProfileModal
        show={showModal || isCreateModalOpen}
        onClose={() => {
          history.replace("/event-profile");
          setShowModal(false)
        }}
        onCreate={handleCreateProfile}
        fetchEventProfiles={fetchEventProfiles}
        createProfile={true}
      />

      <style>{`
        .profile-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 30px 30px 0px 30px;
        }

        .profile-heading {
          font-size: 18px;
          font-weight: 600;
          color: ${dashboardColors[theme].primaryTextColor};
  
        }

          @media (max-width: 769px){
         .profile-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 10px 0px 10px;
        }   
            }
      `}</style>
    </div>
  );
};

export default ProfileHeader;
